import type { SelectOption } from "@shared/types";

/**
 * Filters localized term options by the product config values.
 * Returns only the options whose values are present in the config array.
 *
 * This is a generic filter function that can be used for any localized options
 * (grind, term, etc.) against their corresponding config values.
 */
export const setAvailableLocalisedTermOptions = (localisedOptions: SelectOption[], configValues: string[]) => {
  return localisedOptions.filter((option) => configValues.includes(option.value));
};
